module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/pet-care-rx-ebe44192ed987de54ca89d3b48a967db.png";